import styled, {css} from 'styled-components'

import '@ongov/ontario-design-system-design-tokens/dist/css/_variables.css'

export const SearchResetButton = styled.input`
  position: absolute;
  display: flex;
  align-items: center;
  top: 15px;
  right: 64px;
  height: 28px;
  width: 28px;
  color: #000;
  margin: 0;
  padding: 0.1rem;
  background-color: transparent;
  outline: none;
  border: none;
  cursor: pointer;
  z-index: 10;

  @media (max-width: 72em) {
    top: 15px;
  }

  @media (max-width: 40em) {
    top: 17px;
  }

  ${props =>
    props.searchOpen &&
    css`
      right: 65px;
    `}

  &:focus {
    box-shadow: 0 0 0 4px var(--ontario-colour-system-focus);
  }
`
export const CloseIconContainer = styled.div`
  // Empty CSS to allow JS to add/remove this element.
`
export const CloseIcon = styled.div`
  z-index: 1;
  position: absolute;
  display: flex;
  align-items: center;
  top: 15px;
  right: 63px;
  height: 28px;
  width: 28px;
  color: #000;
  margin: 0;
  padding: 0.1rem;
  outline: none;
  border: none;
  cursor: pointer;

  @media (max-width: 72em) {
    top: 15px;
  }

  @media (max-width: 40em) {
    top: 16px;
  }

  ${props =>
    props.searchOpen &&
    css`
      right: 65px;
    `}

  &:focus {
    box-shadow: 0 0 0 4px var(--ontario-colour-system-focus);
  }
`

export default {SearchResetButton, CloseIconContainer, CloseIcon}
